import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import history from './redux/history';
import { store } from './redux/store';
import { App } from './App';
import './components/CiscoUi/styles/dcloud-shared-ui.css';
import './i18n';
import './styles';
import { ThemeProvider } from './components/CiscoUi/providers/theme';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
